import { FunctionComponent, useLayoutEffect, useRef, useState } from 'react';
import cn from 'classnames';
import ResizeObserver from 'resize-observer-polyfill';
import css from './FilterSidebar.module.less';

const FilterSidebar: FunctionComponent<{ className?: string }> = ({ className, children }) => {
  const ref = useRef<HTMLElement>(null);
  const [top, setTop] = useState(16);

  useLayoutEffect(() => {
    const element = ref.current;
    if (!element) return;

    let previousScrollY = Math.max(0, window.scrollY);
    let minTop = 16;
    let currentTop = 16;

    const updateTop = (value: number) => {
      currentTop = Math.max(minTop, Math.min(16, value));
      setTop(currentTop);
    };

    const updatePosition = () => {
      minTop = Math.min(16, window.innerHeight - element.getBoundingClientRect().height - 16);
      updateTop(currentTop);
    };

    const onScroll = () => {
      const scrollY = Math.max(0, window.scrollY);
      updateTop(currentTop + previousScrollY - scrollY);
      previousScrollY = scrollY;
    };

    updatePosition();
    const observer = new ResizeObserver(updatePosition);
    observer.observe(element);
    window.addEventListener('resize', updatePosition);
    window.addEventListener('scroll', onScroll, { passive: true });

    return () => {
      observer.disconnect();
      window.removeEventListener('resize', updatePosition);
      window.removeEventListener('scroll', onScroll);
    };
  }, []);

  return (
    <aside
      ref={ref}
      className={cn(css.root, className)}
      style={{ top }}
    >
      {children}
    </aside>
  );
};

export default FilterSidebar;
